import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "../../../services/security.js";
import auth from "../../../services/auth.js";
import events from "../../../services/events.js";
import companies from "../../../services/companies.js";

class BankingController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    ProfileService,
    AuthService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $location,
    $scope
  ) {
    this.name = "banking";
    $localStorage.activeStateName = "banking";
    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.loading = true;
    this.$location = $location;
    this.$security = SecurityService;
    this.$profile = ProfileService;
    this.$rootScope = $rootScope;
    this.$common = CommonService;
    this.$env = EnvService;
    this.banks = [];
    this.cards = [];
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    this.currentUser = this.$auth.getUserData();

    if (this.currentUser) {
      this.accountHolderName = this.currentUser.firstName + " " + this.currentUser.lastName;
      this.credit_card_name = this.currentUser.firstName + " " + this.currentUser.lastName;
      this.street = this.currentUser.homeContactInfo.streetLine1;
      this.city = this.currentUser.homeContactInfo.city;
      this.state = this.currentUser.homeContactInfo.state;
      this.zipCode = this.currentUser.homeContactInfo.zipCode;
    }

    this.cardType = "bank";

    const thisYear = new Date().getFullYear();
    const allYears = [thisYear.toString()];

    for (let i = 1; i < 15; i++) {
      allYears.push((thisYear + i).toString());
    }
    //thisMonth = thisMonth + 1;
    this.stateList = [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ];
    this.expYears = {value: thisYear.toString(), values: allYears};
    //this.expMonths = { "value" : thisMonth.toString(), "values" : monthsForDropDrown };
    this.expMonths = {
      value: "01",
      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
    };

    var _this = this;
    _this.getPaymentInfo();
    _this.GetNewPaymentInfoListener = _this.$rootScope.$on("GetNewPaymentInfo", function ($event, params) {
      console.log("params");
      console.dir(params);
      if (params.data.error) {
        _this.handleError(params.data.response);
      } else {
        _this.getPaymentInfo(params, true);
      }
    });
    _this.$scope.$on("$destroy", _this.GetNewPaymentInfoListener);

    this.cardNumberFormatting = {
      creditCard: true,
      delimiter: "-",
      onValueChanged: (e) => {
        this.cardNumber = e.target.rawValue.trim();
      },
    };
  }

  handleError(error) {
    var _this = this;
    let message = error.data.message;
    _this.$timeout(function () {
      _this.loading = false;
      _this.unSetLoader();
    }, 300);
    _this.$timeout(function () {
      alert(message);
    }, 500);
  }

  getPaymentInfo(data, payment_info_just_created) {
    var _this = this;
    _this.$profile.getPaymentInfo().then(
      function (response) {
        _this.handleResponse(response.data, payment_info_just_created, data);
      },
      function (error) {
        console.log("error getting payment info");
        console.dir(error);
      }
    );
  }

  handleResponse(payment_infos, payment_info_just_created, data) {
    var _this = this;
    this.banks = [];
    this.cards = [];
    if (payment_infos && payment_infos.undeletedPaymentInfos && payment_infos.undeletedPaymentInfos.length > 0) {
      let pay_infos_array = payment_infos.undeletedPaymentInfos;
      try {
        try {
          var sorted_array = pay_infos_array.sort(function (a, b) {
            return new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime();
          });
        } finally {
          sorted_array.forEach((payment_info, index) => {
            if (index === 0) {
              if (payment_info.bankName) {
                this.banks.push(payment_info);
              } else {
                this.cards.push(payment_info);
              }
            }
          });
        }
      } catch (err) {
        console.log("error");
        console.dir(err);
      } finally {
        console.log(this.banks);

        if (payment_info_just_created) {
          this.closePaymentDialog(data);
        }
        this.$timeout(() => {
          this.loading = false;
        });
      }
    } else {
      this.$timeout(() => {
        this.loading = false;
      });
    }
  }

  closePaymentDialog(data) {
    var _this = this;
    if (data.data.card) {
      _this.$timeout(function () {
        _this.unSetLoader();
        $("#modal-add-card").modal("hide");
      }, 1000);
    } else {
      _this.$timeout(function () {
        _this.unSetLoader();
        $("#modal-add-account").modal("hide");
      }, 1000);
    }
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  toggleAddPayment() {
    if (!this.addingPayment && (this.banks.length || this.cards.length)) {
      let c = confirm(`If you save a new payment method, then it will replace your existing ${this.banks.length ? "bank account" : "debit card"}.`);
      if (!c) return;
    }

    this.$timeout(() => {
      this.addingPayment = !this.addingPayment;
    });
  }

  triggerPaymentInfoModal(payment_info, type, is_replace) {
    var _this = this;
    let data = {};
    data.info = payment_info;
    data.type = type;
    data.is_replace = is_replace;
    data.jobbler = _this.currentUser;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SettingBankForJobbler", {data});
    });
  }

  addCreditCard() {
    if (
      !this.cardNumber ||
      !this.cvc ||
      !this.street ||
      !this.city ||
      !this.state ||
      !this.zipCode ||
      !this.expMonths ||
      !this.expMonths.value ||
      !this.expYears ||
      !this.expYears.value
    )
      return console.error("Missing fields");

    let data = {};

    data.type = "card";
    data.is_replace = !!(this.cards && this.cards.length);
    data.jobbler = this.currentUser;

    console.log("createCreditCard");
    this.setLoader();
    this.isSaveCreditCardDisabled = true;

    console.log("what is the new credit card");
    console.dir(data);

    this.createRecipient(data);
  }

  addBankAccount() {
    console.log("addBankAccount");
    console.dir(this.isSaveBankAccountDisabled);

    const bank_name = this.accountHolderName;
    const bank_routing = this.routingNumber;
    const bank_account = this.accountNumber;

    if (this.isSaveBankAccountDisabled === true) {
      console.log("were already saving data");
      return;
    }

    if (!bank_name || !bank_routing || !bank_account) {
      return console.error("Missing fields");
    }

    let data = {};

    data.type = "bank";
    data.is_replace = !!(this.banks && this.banks.length);
    data.jobbler = this.currentUser;

    console.log("createBankAccount");
    this.setLoader();
    this.isSaveBankAccountDisabled = true;

    console.log("what is the new bank account");
    console.dir(data);

    this.createRecipient(data);
  }

  createRecipient(data) {
    let pl = null;

    this.bankTokenError = null;
    if (data.type === "card") {
      pl = {
        card: {
          number: this.cardNumber,
          exp_month: this.expMonths.value,
          exp_year: this.expYears.value,
          cvc: this.cvc,
          address_line1: this.street,
          address_city: this.city,
          address_state: this.state,
          address_zip: this.zipCode,
          currency: "usd",
        },
      };
    } else {
      pl = {
        bank_account: {
          country: "us",
          currency: "usd",
          account_holder_name: this.accountHolderName,
          account_holder_type: "individual",
          routing_number: this.routingNumber,
          account_number: this.accountNumber,
        },
      };
    }

    this.$security.getToken(pl).then(
      (response) => {
        console.log("in response from get token");
        console.dir(response);
        this.saveRecipient(response.data, pl, data.type);
      },
      (error) => {
        console.log("in error");
        console.dir(error);
        this.handleRecipientError(error);
        this.unSetLoader();
      }
    );
  }

  handleRecipientError(response) {
    if (response.data.error) {
      this.bankTokenError = response.data.error.message;
      this.isSaveBankAccountDisabled = false;
    } else {
      this.bankTokenError = "There was an issue saving your payment information. Please contact an administrator.";
    }
  }

  saveRecipient(data, payment_info, type) {
    let pl = {};

    if (type === "card") {
      pl.username = this.currentUser.username;
      pl.stripeToken = data.id;
      pl.paymentMethod = "card";
      pl.country = "us";
      pl.currency = "usd";
    } else {
      pl.username = this.currentUser.username;
      pl.stripeToken = data.id;
      pl.paymentMethod = "bank_account";
    }

    this.$security.saveRecipient(pl).then(
      (response) => {
        let data = {};

        if (response.data.status === "error") {
          console.error(response);
          data.response = response;
          data.error = true;
          this.unSetLoader();
          this.$timeout(() => {
            this.$rootScope.$emit("GetNewPaymentInfo", {data});
          });
        } else {
          data.response = response.data;
          this.unSetLoader();

          data.card = type === "card";

          this.$timeout(() => {
            this.$rootScope.$emit("GetNewPaymentInfo", {data});
          });
          this.displayInformativeModal(type, response);
        }

        this.isSaveBankAccountDisabled = false;
      },
      (error) => {
        console.log("in error for saving recipient");
        console.dir(error);
        this.unSetLoader();
        this.isSaveBankAccountDisabled = false;
        alert("There was a fatal error. Please contact an administrator.");
      }
    );
  }

  displayInformativeModal(type, resp) {
    console.log("display modal");
    console.dir(type);
    console.dir(this.currentUser);
    console.dir(resp);
    this.$timeout(() => {
      this.unSetLoader();
    });
    let text = null;
    //https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option
    if (type === "bank") {
      text =
        "We have added your bank account as your primary method for receiving funds. Please learn more about the different types of payment methods ";
    } else {
      text =
        "We have added your debit card as your primary method for receiving funds. Please learn more about the different types of payment methods ";
    }
    this.explaination_text = text;
    this.$timeout(() => {
      this.$timeout(() => {
        this.addingPayment = false;
      });
      $("#explain-payment-info-new").modal();
    });
  }
}

BankingController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "profile",
  "auth",
  "events",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$location",
  "$scope",
];

export default BankingController;



// WEBPACK FOOTER //
// ./client/app/components/jobbler/banking/banking.controller.js